import classNames from "classnames";
import { toast } from "react-toastify";
import React, { useState } from "react";
import {
  ProcedureConsts,
  ProcedureEntity,
} from "../../../application/domain/procedures/procedure-entity";
import { BaseModal } from "../../atoms/base-modal";
import { TextField } from "@graffer-inc/console-design-kit";
import { reportUnexpectedError } from "../../../error-reporter";

export const ProcedureCopyModal: React.FC<{
  onCopy: (newName: string) => Promise<void>;
  procedure: ProcedureEntity;
  onClose: () => void;
  isActive: boolean;
}> = ({ onCopy, procedure, onClose, isActive }) => {
  const newProcNameSuffix = " コピー";
  const defaultProcName =
    procedure.name.length <=
    ProcedureConsts.MAX_NAME_LENGTH - newProcNameSuffix.length
      ? `${procedure.name}${newProcNameSuffix}`
      : procedure.name;
  const [newName, setNewName] = useState<string>(defaultProcName);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const closeModal = () => {
    setNewName("");
    onClose();
  };
  const isInvalidName = () =>
    newName.length === 0 || newName.length > ProcedureConsts.MAX_NAME_LENGTH;
  const copyProcedure = async () => {
    setIsSubmitting(true);
    try {
      await onCopy(newName);
      toast.success("手続きのコピーを作成しました。");
      setIsSubmitting(false);
      closeModal();
    } catch (e) {
      reportUnexpectedError(e);
      toast.error("手続きのコピーに失敗しました。");
      setIsSubmitting(false);
    }
  };

  return (
    <BaseModal
      title={"手続きのコピー"}
      isActive={isActive}
      onClose={closeModal}
    >
      <section className="modal-card-body">
        <div className="field">
          <div className="is-small">
            「{procedure.name}」をコピーして新規手続きを作成します。
          </div>
        </div>
        <div className="field">
          <TextField
            label={"手続き名称"}
            description={"手続き名称を入力してください。"}
            placeholder={""}
            onChange={(e) => {
              setNewName(e.target.value);
            }}
            value={newName}
            errorMessages={
              isInvalidName()
                ? "手続き名称は1文字以上、64文字以下の値を入力してください。"
                : undefined
            }
            required
          />
        </div>
      </section>
      <footer className="modal-card-foot">
        <button className="button is-failure is-fullwidth" onClick={closeModal}>
          キャンセル
        </button>
        <button
          className={classNames("button is-info is-fullwidth", {
            "is-loading": isSubmitting,
          })}
          onClick={copyProcedure}
          disabled={isInvalidName()}
        >
          {"作成する"}
        </button>
      </footer>
    </BaseModal>
  );
};
